import { render, staticRenderFns } from "./ActionsBatchReview.vue?vue&type=template&id=827bc34e"
import script from "./ActionsBatchReview.vue?vue&type=script&lang=js"
export * from "./ActionsBatchReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports